<template>
    <form class="o-alerts">
        <div v-if="alert && alert.id !== undefined">
            <m-title :title="`Potwierdź alert ${alert.id}`" />
            <div class="o-users__controls">
                <m-control
                    type="radio"
                    label="Cała Polska"
                    name="note"
                    @input="alert.wholePoland = $event"
                    :value="alert.wholePoland"
                    :items="[
                        {
                            value: '1',
                            label: 'tak'
                        },
                        {
                            value: '0',
                            label: 'nie'
                        }
                    ]"
                    ref="region"
                />
                <template v-if="alert.wholePoland !== '1'">
                    <m-control
                        type="search"
                        label="Województwa"
                        placeholder="Zakres terytorialny"
                        name="provinces"
                        v-model="alert.provinces"
                        :multiple="true"
                        :object="true"
                    />
                    <m-tags :value="alert.provinces" />
                    <m-control
                        type="search"
                        label="Powiat"
                        placeholder="Zakres terytorialny"
                        name="counties"
                        v-model="alert.counties"
                        :multiple="true"
                        :object="true"
                    />
                    <m-tags :value="alert.counties" />
                </template>
                <m-control
                    type="search"
                    label="Do kogo"
                    placeholder="Odbiorcy..."
                    name="roles"
                    v-model="alert.roles"
                    :multiple="true"
                    :object="true"
                    ref="roles"
                />
                <m-tags :value="alert.roles" />
                <m-control
                    type="search"
                    label="Agrofag"
                    placeholder="Nazwa agrofagu"
                    name="agrofags"
                    v-model="alert.agrofags"
                    :multiple="true"
                    :object="true"
                    ref="agrofags"
                />
                <m-tags :value="alert.agrofags" />
                <m-control
                    type="search"
                    label="Uprawa"
                    placeholder="Nazwa uprawy"
                    name="crops"
                    v-model="alert.crops"
                    :multiple="true"
                    :object="true"
                    ref="crops"
                />
                <m-tags :value="alert.crops" />
                <m-control
                    type="range"
                    label="Zagrożenie"
                    name="danger"
                    @input="alert.danger = $event"
                    :value="alert.danger"
                    :items="5"
                />
                <m-photos
                    :photos="photos"
                    :router-back="{
                        name: 'alerts-approve',
                        params: { id: alert.id }
                    }"
                />
                <m-control
                    type="textarea"
                    label="Treść alertu"
                    placeholder="Wpisz treść alertu..."
                    name="description"
                    v-model="alert.description"
                    ref="description"
                />
            </div>
            <div class="l-row">
                <div class="l-row__column">
                    <a-button
                        :disabled="photos.length === 0"
                        type="fullwidth"
                        :submit="true"
                        :is-processing="alertStatus === 'saving'"
                        @click.prevent="handleSubmit"
                    >
                        Potwierdź alert
                    </a-button>
                </div>
            </div>
        </div>
        <a-spinner v-else />
    </form>
</template>

<script>
export default {
    metaInfo() {
        return {
            title: this.metaTitle
        }
    },
    data() {
        return {
            metaTitle: 'Alert do akceptacji',
            alert: {
                id: '',
                wholePoland: '0',
                roles: [],
                agrofags: [],
                crops: [],
                counties: [],
                provinces: [],
                danger: 0,
                description: ''
            }
        }
    },
    watch: {
        alert: {
            deep: true,
            handler() {
                this.$store.dispatch('setAlertEdited', this.alert)
            }
        }
    },
    computed: {
        alertStatus() {
            return this.$store.getters.alertStatus
        },
        photos() {
            return this.$store.getters.photos
        },
        fetchedAlert() {
            return this.$store.getters.alert
        },
        areas() {
            if (this.alert.wholePoland === '1') {
                return ['1_0_0']
            } else {
                return [
                    ...this.alert.provinces.map(item => `0_${item.id}_0`),
                    ...this.alert.counties.map(item => `0_0_${item.id}`)
                ]
            }
        },
        alertEdited() {
            return this.$store.getters.alertEdited
        }
    },
    methods: {
        handleSubmit() {
            if (this.areas.length === 0) {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Uzupełnij obszar'
                })
                this.$scrollTo(this.$refs.region, 0)
                return false
            }
            if (this.alert.roles.length === 0) {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Uzupełnij pole "Do kogo"'
                })
                this.$refs.roles.$el.querySelector('input').focus()
                return false
            }
            if (
                this.alert.agrofags.length === 0 &&
                this.alert.crops.length === 0
            ) {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Uzupełnij pole agrofagu lub uprawy'
                })
                this.$refs.agrofags.$el.querySelector('input').focus()
                return false
            }
            if (this.alert.description === '') {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Uzupełnij opis alertu'
                })
                this.$refs.description.$el.querySelector('textarea').focus()
                return false
            }
            this.$store
                .dispatch('updateAlert', {
                    id: this.alert.id,
                    body: {
                        areas: this.areas,
                        roles: { _ids: this.alert.roles.map(item => item.id) },
                        agrofags: {
                            _ids: this.alert.agrofags.map(item => item.id)
                        },
                        crops: { _ids: this.alert.crops.map(item => item.id) },
                        danger: this.alert.danger.toString(),
                        alert_status_id: 2, // published
                        description: this.alert.description,
                        image: this.$store.getters.photosInBase64
                    }
                })
                .then(() => {
                    this.$store.dispatch('resetAlertEdited')
                    this.$store.dispatch('removeAllPhotos')
                    this.$store.dispatch('addNotification', {
                        type: 'success',
                        content: 'Zaakceptowano alert.'
                    })
                    this.$router.push({ name: 'alerts' })
                })
        },
        fetchAlert() {
            if (!isNaN(this.$route.params.id)) {
                this.$store
                    .dispatch('fetchAlert', this.$route.params.id)
                    .then(() => {
                        if (this.fetchedAlert.counties) {
                            this.$set(
                                this.alert,
                                'counties',
                                this.fetchedAlert.counties.map(item => {
                                    return {
                                        name: item.name,
                                        id: item.ogr_fid
                                    }
                                })
                            )
                        }
                        if (this.fetchedAlert.provinces) {
                            this.$set(
                                this.alert,
                                'provinces',
                                this.fetchedAlert.provinces.map(item => {
                                    return {
                                        name: item.jpt_nazwa_,
                                        id: item.ogr_fid
                                    }
                                })
                            )
                        }
                        this.$set(this.alert, 'id', this.fetchedAlert.id)
                        this.$set(this.alert, 'crops', this.fetchedAlert.crops)
                        this.$set(
                            this.alert,
                            'agrofags',
                            this.fetchedAlert.agrofags
                        )
                        this.$set(
                            this.alert,
                            'danger',
                            this.fetchedAlert.danger
                        )
                        this.$set(
                            this.alert,
                            'description',
                            this.fetchedAlert.description
                        )
                        this.$set(this.alert, 'roles', this.fetchedAlert.roles)
                        this.$set(
                            this.alert,
                            'wholePoland',
                            this.fetchedAlert.whole_poland ? '1' : '0'
                        )
                        // photos
                        if (
                            this.fetchedAlert.images &&
                            this.fetchedAlert.images.length > 0
                        ) {
                            this.$store.dispatch(
                                'fetchPhotos',
                                this.fetchedAlert.images.map(
                                    photo => photo.full_path
                                )
                            )
                        }

                        // meta title
                        this.metaTitle = `Potwierdź alert ${this.alert.id}`
                    })
            } else {
                this.$router.push({ name: 'error404' })
            }
        }
    },
    created() {
        if (
            Object.keys(this.alertEdited).length !== 0 &&
            +this.alertEdited.id === +this.$route.params.id
        ) {
            this.$set(this, 'alert', this.alertEdited)
        } else {
            this.fetchAlert()
        }
    }
}
</script>
